/**
 * A small picture of what is selected on page `page` (AC-UX-10), cut from the page's canvas as drawn: the selection
 * marks are areas over the canvas, not in it. Undefined when the page is not drawn or nothing on it is selected.
 */
export function snapshot(page: number, maxW = 560, maxH = 400): string | undefined {
  const section = document.querySelector(`section[data-testid="page-${page}"]`);
  const canvas = document.querySelector<HTMLCanvasElement>(`canvas[data-testid="canvas-${page}"]`);
  if (!section || !canvas?.width) return undefined;
  // A selected object's areas are its children (its button is only an anchor).
  const rects = [...section.querySelectorAll('[data-selected="true"] > span')].map((el) => el.getBoundingClientRect()).filter((r) => r.width > 0 && r.height > 0);
  if (!rects.length) return undefined;
  const c = canvas.getBoundingClientRect();
  const k = canvas.width / c.width;
  const pad = 4;
  const x0 = Math.max(0, Math.min(...rects.map((r) => r.left)) - c.left - pad) * k;
  const y0 = Math.max(0, Math.min(...rects.map((r) => r.top)) - c.top - pad) * k;
  const x1 = Math.min(c.width, Math.max(...rects.map((r) => r.right)) - c.left + pad) * k;
  const y1 = Math.min(c.height, Math.max(...rects.map((r) => r.bottom)) - c.top + pad) * k;
  if (x1 <= x0 || y1 <= y0) return undefined;
  const fit = Math.min(1, (maxW * devicePixelRatio) / (x1 - x0), (maxH * devicePixelRatio) / (y1 - y0));
  const out = document.createElement('canvas');
  out.width = Math.max(1, Math.round((x1 - x0) * fit));
  out.height = Math.max(1, Math.round((y1 - y0) * fit));
  out.getContext('2d')!.drawImage(canvas, x0, y0, x1 - x0, y1 - y0, 0, 0, out.width, out.height);
  return out.toDataURL('image/png');
}
